module.exports = __webpack_public_path__ + "static/img/015.633eaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/015.png
// module id = DLkX
// module chunks = 0